import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=d6050eae&scoped=true"
import script from "./SuppliersList.vue?vue&type=script&lang=js"
export * from "./SuppliersList.vue?vue&type=script&lang=js"
import style0 from "./SuppliersList.vue?vue&type=style&index=0&id=d6050eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6050eae",
  null
  
)

export default component.exports